<template>
  <BaseButton
    v-bind="$attrs"
    :background-colour="colour"
    :outline="true"
    :to="to"
  >
    <template #content>
      <slot />
    </template>
  </BaseButton>
</template>

<script>
export default {
  name: 'OutlineButton',

  props: {
    colour: {
      type: String,
      default: 'white',
      validator: value => [
        'white',
        'black',
      ].includes(value)
    },
    to: { type: [String, Object], required: false, default: '' },
  },
}
</script>
